import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { isLocal, domain } from '../../../config';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

export default ({ user, name, permissions, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown nav isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} style={{ padding: '0 5px' }}>
      <DropdownToggle nav className="account_name">
        <p><FormattedMessage id={name} /></p>
      </DropdownToggle>
      <DropdownMenu right>{children.map(child => (
        user.permissions.includes(permissions[0]) || user.permissions.includes(permissions[1]) ? (
          <a key={child.name} href={`${path}${child.url}`}
            target={user.options.all_in_one_tab ? "_self" : "_blank"}
            rel="noreferrer">
            <DropdownItem><FormattedMessage id={child.name} /></DropdownItem>
          </a>
        ) : null))}
      </DropdownMenu>
    </Dropdown>
  );
};



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdownCompany/Item.js